/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from "react"
import { numberWithCommas } from "../../utils/format"
import Dropdown from "../../modules/dataset/components/Dropdown"
import BreadCrumb from "../components/BreadCrumb"
import FilterGroup from "./components/FilterGroup"
import { ExploreItem, ExploreItemType } from "./components/ExploreItem"
import { useExploreData } from "../useExploreData"
import LoadingIndicator from "../../components/LoadingIndicator"



const ExploreTables = () => {

  const {
    publicTables,
    refecth,
    isLoading
  } = useExploreData()

  if (isLoading) return <LoadingIndicator />

  return <div className="" key="12312312">
    <div className="border-b-2 px-6 py-2 flex justify-between items-center">
      <BreadCrumb  >
        Explore
        <span className="mx-3">/</span>
        Browse Tables ({publicTables.length || 0})
      </BreadCrumb>
      <FilterGroup />
    </div>
    <div className="px-16 py-8">
      {/* List of Items */}
      <div id="section-content" className=" flex justify-between flex-wrap">
        {
          publicTables.map((item, index) => {
            return <ExploreItem type={ExploreItemType.TABLE} key={index}
              title={item?.name}
              author={item?.owner?.name}
              imgUrl={item?.image}
              description={item?.detail}
              item={item} />
          })
        }
      </div>
    </div>
  </div>
}

export default ExploreTables;